import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../pageSection/pageSection.js"
import H1 from "../../h1/h1.js"
import H2 from "../../h2/h2.js"
import P from "../../p/p.js"

import styles from "./differentiators.module.scss"

const DifferentiatorsSection = () => {
  const data = useStaticQuery(graphql`
    query {
      videoGameController: file(relativePath: { eq: "about/video-game-controller.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 750
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      bicycle: file(relativePath: { eq: "about/bicycle.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 750
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      smartWatch: file(relativePath: { eq: "about/smart-watch.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 750
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <PageSection backgroundColor="#ffffff">
      <div className={styles.contentContainer}>
        <div className={styles.headingContainer}>
          <H1 className={styles.h1} slideUp>What Makes Us Different</H1>
          <div className={styles.yellowBar} />
        </div>
      </div>

      <ul className={styles.listRoot}>
        <li className={styles.listItem}>
          <div className={styles.copyContainer}>
            <H2 className={styles.h2}>Building smarter spenders</H2>
            <P className={styles.p}>In the real world, we need to know how to spend money. When kids use Till, they develop this skill set by making everyday spend vs save trade-offs that will serve them for the rest of their lives. With the Till platform, parents can trust kids with their own debit card and work together to set goals and better prepare them to be out on their own.</P>
          </div>
          <div className={styles.imageContainer}>
            <div
              data-sal="slide-left"
              data-sal-delay="100"
              data-sal-duration="1000"
              data-sal-easing="ease"
            >
              <GatsbyImage
                image={getImage(data.bicycle)}
                alt="Teenager smiling and leaning against the wall while holding and showing a Till debit card"
                width={750}
              />
            </div>
          </div>
        </li>
        <li className={styles.listItem}>
          <div className={styles.oddCopyContainer}>
            <H2 className={styles.h2}>Helping families work together</H2>
            <P className={styles.p}>At Till, we believe the journey to becoming a smarter spender is a team sport. We built our philosophy on teachable “money moments:” parts of everyday family life that stand out as unique opportunities to teach kids about money. It’s not one big conversation, it's lots of little ones.</P>
          </div>
          <div className={styles.imageContainer}>
            <div
              data-sal="slide-right"
              data-sal-delay="100"
              data-sal-duration="1000"
              data-sal-easing="ease"
            >
              <GatsbyImage
                image={getImage(data.videoGameController)}
                alt="Father having a discussion about money with two teenagers"
                width={750}
              />
            </div>
          </div>
        </li>
        <li className={styles.listItem}>
          <div className={styles.copyContainer}>
            <H2 className={styles.h2}>A flexible experience that fits you</H2>
            <P className={styles.p}>Raising kids is hard enough without having to learn and adapt to another system: chore charts, allowance tracking, money jars… We build Till to be flexible because every family is different. It’s our job to put the tools in your hands and let life do the rest.</P>
          </div>
          <div className={styles.imageContainer}>
            <div
              data-sal="slide-left"
              data-sal-delay="100"
              data-sal-duration="1000"
              data-sal-easing="ease"
            >
              <GatsbyImage
                image={getImage(data.smartWatch)}
                alt="Teenager using a Till debit card to make a purchase in a coffee shop"
                width={750}
              />
            </div>
          </div>
        </li>
      </ul>
    </PageSection>
  )
}

export { DifferentiatorsSection }
